import { action, computed } from 'mobx';
import Alert from 'react-s-alert';

import { Variables, AppManager } from 'core/index';

import {
  GroupsApp,
  GroupModel,
  InviteLinkApp,
  InviteLinkModel,
} from 'apps/group/app';

import {
  GroupsQuery,
  InitiativeInvLinkQuery,
  ProjectInvLinkQuery,
} from 'apps/group/gql';

export class GroupsAppManager extends AppManager {
  static registryName = 'GroupsAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('groups', GroupsApp);
    this.AppRef('inviteLink', InviteLinkApp);
    this.variables = new Variables({
      spaceSlug: () =>
        this.params.get('profile') ||
        this.params.get('initiative') ||
        this.params.get('spacePath') ||
        `#${this.params.get('channel')}`,
      slug: () => this.params.get('slug') || '',
    });
    this.variables.onChange(['space', 'slug'], this.NewParams);
  }

  @computed
  get loading() {
    return (
      this.queries.get('groups')?.loading ||
      this.queries.get('inviteLink')?.loading
    );
  }

  @action
  NewParams = () => {
    this.NewGroupsQuery();
    this.NewLinkQuery();
  };

  @action
  NewGroupsQuery = () => {
    const groupsQ = new GroupsQuery(this, {
      queryKey: 'groups',
      onSysErr: this.onError,
    });
    groupsQ.process(groups => {
      if (groups !== null) {
        return groups.map(group => GroupModel.Load(group));
      }
      return [];
    }, this.GroupsUpdate);
    groupsQ.query();
  };

  @action
  NewLinkQuery = () => {
    let spaceQ;
    if (this.variables.slug === '') {
      spaceQ = InitiativeInvLinkQuery;
    } else {
      spaceQ = ProjectInvLinkQuery;
    }
    // eslint-disable-next-line
    const inviteLinkQ = new spaceQ(this, {
      queryKey: 'inviteLink',
      onSysErr: this.onError,
    });
    inviteLinkQ.process(
      invLink => InviteLinkModel.Load(invLink),
      this.InvLinkUpdate,
    );
    inviteLinkQ.query();
  };

  @action
  onError = () => {
    Alert.error('Hmm... Something went wrong! Please try again.');
  };

  @action
  GroupsUpdate = groupModels => {
    this.groups = groupModels;
    this.groups.ResetLocals();
    // NOTE: Some logs used during debugging the "set locals" bug.
    // console.log('this.groups:', this.groups);
    // console.log(this.groups.map((group) => {
    //   return group.id;
    // }));
  };

  @action
  InviteMembers = () => {
    // NOTE: This mutation is currently on the GroupApp due to a bug.
    // Leaving this here as a reminder.
  };

  @action
  RemoveMember = () => {
    // NOTE: This mutation is currently on the GroupApp due to a bug.
    // Leaving this here as a reminder.
  };

  @action
  InvLinkUpdate = invLink => {
    if (invLink) {
      this.inviteLink = invLink;
    } else {
      this.inviteLink = new InviteLinkApp(this);
    }
    this.inviteLink.init();
  };
}
